import React from "react";
import EmptyState from "../EmptyState";
import useRandom from "@hooks/useRandom";

type ImageComponent = () => React.JSX.Element;

interface RandomEmptyStateProps {
  images: ImageComponent[];
  texts: {
    title: string;
    subtitle: string;
  }[];
}

const RandomEmptyState: React.FC<RandomEmptyStateProps> = ({ images, texts }) => {
  const RandomImage = useRandom(images);
  const { subtitle, title } = useRandom(texts);

  return (
    <EmptyState icon={<RandomImage />} title={title}>
      {subtitle}
    </EmptyState>
  );
};

export default RandomEmptyState;
